import { render } from "./maintenance.widget.wp.vue?vue&type=template&id=6d9be255"
import script from "./maintenance.widget.wp.vue?vue&type=script&lang=js"
export * from "./maintenance.widget.wp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__